/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestMaxStorageSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_MAX_STORAGE_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class NewAutoTestMaxStorageSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestMaxStorageSizeSettingParser.decode(input).map(res => new NewAutoTestMaxStorageSizeSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestMaxStorageSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestMaxStorageSizeSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestMaxStorageSizeSettingParser.schema();
    }
}
